"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var order = ['pages', 'help'];
var createSearchIndexes = function createSearchIndexes(_ref) {
  var _sys$environment;
  var sys = _ref.sys,
    fields = _ref.fields;
  var site = process.env.NEXT_PUBLIC_SITE;
  var env = (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$environment = sys.environment) === null || _sys$environment === void 0 ? void 0 : _sys$environment.sys, 'id');
  if (!site || !env) return [];
  return (0, _utils.getProp)(fields, 'indexes', []).sort(function (a, b) {
    return order.indexOf(a) - order.indexOf(b);
  }).map(function (index) {
    return "".concat(site, "_").concat(env, "_").concat(index);
  });
};
var createSearchInput = function createSearchInput(_ref2) {
  var _sys$contentType;
  var sys = _ref2.sys,
    fields = _ref2.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    placeholder: (0, _utils.getProp)(fields, 'placeholder'),
    openSearch: (0, _utils.getProp)(fields, 'openSearch'),
    closeSearch: (0, _utils.getProp)(fields, 'closeSearch'),
    indexes: createSearchIndexes({
      sys: sys,
      fields: fields
    })
  };
};
var _default = createSearchInput;
exports["default"] = _default;